import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { IntegratedDataSetRecordFilterParameterDialog } from "../Ui/Dialogs/IntegratedDataSetRecordFilterParameterDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandIntegratedDataSetRecordFilterPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandIntegratedDataSetRecordFilterProperties = {
    [name in keyof EntityCommandIntegratedDataSetRecordFilterPropertyValues]: Property<EntityCommandIntegratedDataSetRecordFilterPropertyValues[name]>
};

export interface IEntityCommandIntegratedDataSetRecordFilter extends IEntityCommand, EntityCommandIntegratedDataSetRecordFilterProperties
{
}

export class EntityCommandIntegratedDataSetRecordFilter extends EntityCommand implements IEntityCommandIntegratedDataSetRecordFilter
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandIntegratedDataSetRecordFilter";
    public static override className = "EntityCommandIntegratedDataSetRecordFilter";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandIntegratedDataSetRecordFilterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Filter",
                entityName: "IntegratedDataSetRecord",
                key: "FILTER",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandIntegratedDataSetRecordFilterPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller)
                        return;

                    if (!caller.integratedDataSetRecordFilterParameterDialog)
                        caller.integratedDataSetRecordFilterParameterDialog = new IntegratedDataSetRecordFilterParameterDialog();

                    return (
                        (caller.integratedDataSetRecordFilterParameterDialog as IntegratedDataSetRecordFilterParameterDialog)
                            .openAsync()
                            .then(data =>
                            {
                                if (data.dialogResult !== DialogResultEnum.ok)
                                    return;

                                return data.promiseData;
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

